import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: auto;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  max-width: 1024px;
`;
export const Body = styled.div<{ fromExtension?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({fromExtension}) => !fromExtension && `max-height: 500px;`}
`;
export const TrialBanner = styled.div<{ background: string; border: string }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ${props => props.background};
  border: 1px solid ${props => props.border};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
`;

export const TrialBannerText = styled.span<{ color: string }>`
  font-size: 13px;
  color: ${props => props.color};
  line-height: 1.5;
  flex: 1;
`;

export const TrialBannerStrong = styled.strong<{ color: string }>`
  color: ${props => props.color};
`;

export const ContentResumeValueText = styled.div`
  min-width: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
